// extracted by css-extract-rspack-plugin
export default {"iframeWrapper":"_3da5e9ac","iframe":"_48b28a3f"};